import NotImplementedError from "../NotImplementedError.js";

/**
 *
 * @version 2026-09-03
 * @author Patrik Harag
 */
export default class Parser {

    /**
     *
     * @return string
     */
    getKey() {
        throw new NotImplementedError();
    }

    /**
     *
     * @return string
     */
    getDisplayName() {
        throw new NotImplementedError();
    }

    /**
     *
     * @return string
     */
    getExtension() {
        throw new NotImplementedError();
    }

    /**
     *
     * @param text {string}
     * @param logger {Logger}
     * @return Transaction[]
     */
    parse(text, logger) {
        throw new NotImplementedError();
    }
}